import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'approvalState' })
export class ApprovalStatePipe implements PipeTransform {
  transform(obj: any, args?: any): any {
    let result = null;
    switch (obj) {
      case 'WAIT':
        result = '대기중';
        break;
      case 'APPROVED':
        result = '승인';
        break;
      case 'REJECT':
        result = '반려';
        break;
      case 'CENCEL':
        result = '취소';
        break;
    }
    return result;
  }
}
